import {API} from 'aws-amplify';

export const NEWS_STAFF_FETCH_NEWS_STAFF_LIST_REQUEST = 'NEWS_STAFF_FETCH_NEWS_STAFF_LIST_REQUEST';
export const NEWS_STAFF_FETCH_NEWS_STAFF_LIST_SUCCESS = 'NEWS_STAFF_FETCH_NEWS_STAFF_LIST_SUCCESS';
export const NEWS_STAFF_FETCH_NEWSSTAFF_LIST_FAILURE = 'NEWSSTAFF_FETCH_NEWSSTAFF_LIST_FAILURE';
export const STAFF_NEWS_CREATE_NEW_CANCEL = 'STAFF_NEWS_CREATE_NEW_CANCEL';

export function fetchNewsStaffListRequest() {
  return {
    type: NEWS_STAFF_FETCH_NEWS_STAFF_LIST_REQUEST
  };
}

export function fetchNewsStaffListSuccess(data) {
  return {
    type: NEWS_STAFF_FETCH_NEWS_STAFF_LIST_SUCCESS,
    news_staff_list: data,
    received_at: Date.now()
  };
}

export function fetchNewsStaffList() {
  return function (dispatch) {
    dispatch(fetchNewsStaffListRequest());
    API.get('news-staff', `/get-all`)
      .then(response => {
        // console.log(response);
        dispatch(fetchNewsStaffListSuccess(response));
      })
      .catch(error => {
        console.log(error);
      });
  };
}

// export function fetchTransferDetails(id) {
//   return function(dispatch) {
//     // console.log(aws_cognito_id)
//     dispatch(loadTransferDetailsRequest());
//     API.get("transfers", `/get/${id}`)
//       .then(response => {
//         // console.log(response);
//         dispatch(loadTransferDetailsSuccess(response));
//       })
//       .catch(error => {
//         console.log(error);
//       });
//   };
// }

export async function createNewStaffNewsInDatabase(data) {
  let database_result = API.post('news-staff', `/create/in-database`, {
    body: {
      ...data
    }
  })
    .then(database_result => {
      // console.log(database_result)
      return database_result;
    })
    .catch(error => {
      console.log(error);
    });
  return database_result;
}

export function createNewStaffNews(data) {
  return async function (dispatch) {
    // dispatch(newTransferCreationDatabaseStart());
    try {
      let database_result = await createNewStaffNewsInDatabase(data);
      // dispatch(newTransferCreationDatabaseSuccess(database_result.insertId));
      return database_result;
    } catch (e) {
      console.log(e);
    }
  };
}

// export function fetchStaffList() {
//   return function(dispatch) {
//     dispatch(requestStaffListRequest);
//
//     API.get("crm", `/staff/get-list`)
//       .then(response => {
//         console.log(response);
//         dispatch(receiveStaffList(response));
//       })
//       .catch(error => {
//         console.log(error);
//       });
//   };
// }

// export function fetchStaffListNotDeleted() {
//   return function(dispatch) {
//     dispatch(requestStaffListRequest);
//
//     API.get("crm", `/staff/get-list-not-deleted`)
//       .then(response => {
//         // console.log(response);
//         dispatch(receiveStaffList(response));
//       })
//       .catch(error => {
//         console.log(error);
//       });
//   };
// }
//
// export function selectTransferUi(value) {
//   return {
//     type: TRANSFERS_SELECT_UI,
//     value: value
//   };
// }

// async function createNewUserWithAws(username, password) {
//   const newUser = await Auth.signUp({
//     username: username,
//     password: password
//   });
//   return newUser;
// }

// export async function create_new_user_in_database(
//   aws_cognito_id,
//   email,
//   first_name,
//   last_name
// ) {
//   API.post("crm", `/staff/create/in-database`, {
//     body: {
//       email: email,
//       aws_cognito_id: aws_cognito_id,
//       first_name: first_name,
//       last_name: last_name
//     }
//   })
//     .then(database_result => {
//       return database_result;
//     })
//     .catch(error => {
//       console.log(error);
//     });
// }
//
export function cancelCreateNewStaffNews() {
  return {
    type: STAFF_NEWS_CREATE_NEW_CANCEL
  };
}
//
// export function setTransferSelectId(id) {
//   return {
//     type: TRANSFERS_SELECT_SET_ID,
//     value: id
//   };
// }
//
// export function loadStaffMemberDetails(aws_cognito_id) {
//   return async function(dispatch) {
//     dispatch(loadStaffMemberDetailsRequest(aws_cognito_id));
//
//   };
// }
//
// export function loadTransferDetailsRequest() {
//   return {
//     type: TRANSFERS_FETCH_TRANSFER_REQUEST
//   };
// }
// export function loadTransferDetailsSuccess() {
//   return {
//     type: TRANSFERS_FETCH_TRANSFER_SUCCESS
//   };
// }
// export function startNewTransferCreation() {
//   return {
//     type: TRANSFERS_START_NEW_TRANSFER_CREATION
//   };
// }
// export function updateNewTransferCreationTransferType(client_type) {
//   return {
//     type: TRANSFERS_UPDATE_NEW_TRANSFER_CREATION_TRANSFER_TYPE,
//     value: client_type
//   };
// }
// export function updateNewTransferCreation(key, value) {
//   // console.log(key, value);
//   return {
//     type: TRANSFERS_UPDATE_NEW_TRANSFER_CREATION,
//     value: { key, value }
//   };
// }
// export function newTransferCreationDatabaseStart() {
//   return {
//     type: TRANSFERS_NEW_TRANSFER_DATABASE_CREATE_REQUEST
//   };
// }
// export function newTransferCreationDatabaseSuccess(id) {
//   return {
//     type: TRANSFERS_NEW_TRANSFER_DATABASE_CREATE_SUCCESS,
//     value: id
//   };
// }

//
// export function createNewStaffMemberStart() {
//   return {
//     type: STAFF_CREATE_NEW_START
//   };
// }
//
// export function createNewStaffMemberComplete() {
//   return {
//     type: STAFF_CREATE_NEW_COMPLETE
//   };
// }
